import { gql } from "@apollo/client";
import { FlowsFragment } from "../fragments/flows";

const TEST_RUNS_QUERY = gql`
  ${FlowsFragment}
  query test_flows($first: Int, $after: String, $last: Int, $before: String) {
    flows(purpose: "proof", archived: false, first: $first, after: $after, last: $last, before: $before) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          ...FlowsFragment
        }
      }
    }
  }
`;

export { TEST_RUNS_QUERY };
